import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Linkedin, Mail } from 'lucide-react';
export function Contact() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24 min-h-[70vh] flex flex-col justify-center" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-128">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight mb-8" data-id="element-129">
          Let's connect.
        </h1>
        <p className="text-xl text-gray-600 mb-16 leading-relaxed" data-id="element-130">
          I'm always open to discussing product management, AI/Voice UX, or
          opportunities to build impactful products.
        </p>

        <div className="flex flex-col gap-6" data-id="element-131">
          <a href="mailto:hello@example.com" className="group flex items-center justify-between p-6 md:p-8 border border-gray-200 rounded-2xl hover:border-black hover:bg-gray-50 transition-all" data-id="element-132">
            <div className="flex items-center gap-4" data-id="element-133">
              <div className="w-12 h-12 bg-black text-white rounded-full flex items-center justify-center" data-id="element-134">
                <Mail className="w-5 h-5" data-id="element-135" />
              </div>
              <div data-id="element-136">
                <div className="font-semibold text-lg" data-id="element-137">Email</div>
                <div className="text-gray-500" data-id="element-138">hello@example.com</div>
              </div>
            </div>
            <ArrowUpRight className="w-6 h-6 text-gray-400 group-hover:text-black transition-colors" data-id="element-139" />
          </a>

          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between p-6 md:p-8 border border-gray-200 rounded-2xl hover:border-black hover:bg-gray-50 transition-all" data-id="element-140">
            <div className="flex items-center gap-4" data-id="element-141">
              <div className="w-12 h-12 bg-[#0A66C2] text-white rounded-full flex items-center justify-center" data-id="element-142">
                <Linkedin className="w-5 h-5" data-id="element-143" />
              </div>
              <div data-id="element-144">
                <div className="font-semibold text-lg" data-id="element-145">LinkedIn</div>
                <div className="text-gray-500" data-id="element-146">Connect professionally</div>
              </div>
            </div>
            <ArrowUpRight className="w-6 h-6 text-gray-400 group-hover:text-black transition-colors" data-id="element-147" />
          </a>
        </div>
      </motion.div>
    </div>;
}